import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export function HeaderHeart({ mobile = false }) {
  if (mobile) return (
    <Link to="/community-unterstuetzen" aria-label="Community unterstützen – Klick mich" data-testid="mobile-support-heart" className="relative flex flex-col items-center justify-center w-11 h-12 active:scale-90 transition-transform">
      <span className="relative w-8 h-8 rounded-full bg-rose-50 ring-1 ring-pink-200 flex items-center justify-center">
        <span className="absolute inset-0 rounded-full hh-glow" aria-hidden />
        <Heart className="relative w-[17px] h-[17px] text-rose-600 fill-rose-500 hh-beat" />
      </span>
      <span className="mt-0.5 text-[10px] leading-none font-extrabold text-rose-600 whitespace-nowrap">Klick mich</span>
    </Link>
  );
  return (
    <Link to="/community-unterstuetzen" aria-label="Community unterstützen – Klick mich" data-testid="nav-support-heart" title="Gemeinsam mehr erreichen"
      className="group relative inline-flex items-center gap-1.5 h-9 pl-1.5 pr-2.5 rounded-full hover:bg-rose-50 transition-colors">
      <span className="relative w-7 h-7 rounded-full bg-rose-50 ring-1 ring-pink-200 flex items-center justify-center">
        <span className="absolute inset-0 rounded-full hh-glow" aria-hidden />
        <Heart className="relative w-4 h-4 text-rose-600 fill-rose-500 hh-beat" />
      </span>
      <span className="text-xs font-extrabold text-rose-600 whitespace-nowrap">Klick mich</span>
    </Link>
  );
}
